export default {"src":"/_next/static/media/XLS.0c664422.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};